import React from 'react';

/**
 * WSPOLNY zestaw ikon (V.6).
 *
 * Powstal, bo w panelu bylo ~60 emotek uzytych jako ikony, a nie bylo skad wziac zamiennika:
 * istnialy trzy OSOBNE zestawy (`pages/calendar/icons.js`, `pages/inventory/icons.js`,
 * `pages/GenerateOffer/icons.js`), kazdy widoczny tylko dla swojego katalogu. Strony spoza nich
 * nie mialy zadnej ikony pod reka, wiec siegano po emotke.
 *
 * DLACZEGO NIE EMOTKA: emotka jest obrazkiem z wlasnymi kolorami, wiec nie dziedziczy motywu i w
 * trybie ciemnym zostaje jaskrawa plama. Wyglada tez inaczej na kazdym systemie, a czesc czytnikow
 * ekranu odczytuje jej pelna nazwe posrodku zdania. Ikona stroke na `currentColor` dziedziczy
 * kolor i rozmiar tekstu, w ktorym stoi.
 *
 * KONWENCJA: inaczej niz w trzech starszych zestawach, te ikony przyjmuja `size` (domyslnie 20) i
 * przepuszczaja reszte propsow. Starsze maja rozmiar wpisany na stale, przez co przy kazdym uzyciu
 * poza domyslnym trzeba bylo skalowac je CSS-em z zewnatrz (tak jak w `calendar.styles.js`).
 * Nowe uzycia biora ten zestaw; starsze zostaja nietkniete, zeby nie mieszac dwoch zmian naraz.
 * Domyslne 20 px NIE jest przypadkowe: tyle maja ikony w istniejacych zestawach projektu i tyle
 * zaleca baza ui-ux-pro-max dla elementow sterujacych. Pierwotnie ustawilem 18 i bylaby to
 * TRZECIA wartosc w zestawie, ktory ma liczbe wartosci zmniejszac.
 *
 * `aria-hidden` jest domyslne: ikona stoi zwykle OBOK tekstu, ktory niesie znaczenie, wiec jej
 * powtarzanie przez czytnik ekranu tylko przeszkadza. Gdy ikona jest jedyna trescia (np. przycisk
 * bez etykiety), podaj `aria-hidden={false}` i `aria-label`.
 */

const Svg = ({ size = 20, children, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    /* `verticalAlign` dla uzycia W TEKSCIE: emotka siadala na linii pisma sama, SVG bez tego
       zwisa ponizej i wyglada na przesunieta. W pojemniku `flex` ta wlasciwosc nic nie zmienia,
       wiec jeden domyslny styl obsluguje oba przypadki i nie trzeba ruszac pojemnikow. */
    style={{ flexShrink: 0, verticalAlign: '-0.15em', ...(rest.style || {}) }}
    {...rest}
  >
    {children}
  </svg>
);

const s = { stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };

export const SendIcon = (p) => (
  <Svg {...p}>
    <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" {...s} />
    <path d="m21.854 2.147-10.94 10.939" {...s} />
  </Svg>
);

export const PlusIcon = (p) => (
  <Svg {...p}><path d="M12 5v14M5 12h14" {...s} /></Svg>
);

export const WalletIcon = (p) => (
  <Svg {...p}>
    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" {...s} />
    <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" {...s} />
  </Svg>
);

export const CheckIcon = (p) => (
  <Svg {...p}><path d="M20 6 9 17l-5-5" {...s} /></Svg>
);

export const XIcon = (p) => (
  <Svg {...p}><path d="M18 6 6 18M6 6l12 12" {...s} /></Svg>
);

export const AlertIcon = (p) => (
  <Svg {...p}>
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" {...s} />
    <path d="M12 9v4M12 17h.01" {...s} />
  </Svg>
);

export const InfoIcon = (p) => (
  <Svg {...p}><circle cx="12" cy="12" r="9" {...s} /><path d="M12 11v5M12 8h.01" {...s} /></Svg>
);

export const BanIcon = (p) => (
  <Svg {...p}><circle cx="12" cy="12" r="9" {...s} /><path d="m5.6 5.6 12.8 12.8" {...s} /></Svg>
);

export const TrashIcon = (p) => (
  <Svg {...p}>
    <path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" {...s} />
    <path d="M19 6v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6" {...s} />
  </Svg>
);

export const EditIcon = (p) => (
  <Svg {...p}>
    <path d="M12 20h9" {...s} />
    <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" {...s} />
  </Svg>
);

export const DownloadIcon = (p) => (
  <Svg {...p}><path d="M12 3v12m0 0 4-4m-4 4-4-4M4 19h16" {...s} /></Svg>
);

export const ArrowLeftIcon = (p) => (
  <Svg {...p}><path d="M15 18 9 12l6-6" {...s} /></Svg>
);

export const MailIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" {...s} />
    <path d="m3 7 9 6 9-6" {...s} />
  </Svg>
);

export const SearchIcon = (p) => (
  <Svg {...p}><circle cx="11" cy="11" r="7" {...s} /><path d="m20 20-3.5-3.5" {...s} /></Svg>
);

export const RefreshIcon = (p) => (
  <Svg {...p}>
    <path d="M21 12a9 9 0 1 1-3-6.7" {...s} />
    <path d="M21 4v5h-5" {...s} />
  </Svg>
);

export const LockIcon = (p) => (
  <Svg {...p}>
    <rect x="4" y="10" width="16" height="11" rx="2" {...s} />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" {...s} />
  </Svg>
);

export const UserIcon = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="4" {...s} />
    <path d="M5 21a7 7 0 0 1 14 0" {...s} />
  </Svg>
);

export const UsersIcon = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8" r="3.5" {...s} />
    <path d="M2.5 21a6.5 6.5 0 0 1 13 0" {...s} />
    <path d="M16 5.5a3.5 3.5 0 0 1 0 6.9M18 21a6.5 6.5 0 0 0-2.5-5.1" {...s} />
  </Svg>
);

export const StarIcon = (p) => (
  <Svg {...p}>
    <path d="m12 3.5 2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.5 9.7l5.9-.9Z" {...s} />
  </Svg>
);

export const PackageIcon = (p) => (
  <Svg {...p}>
    <path d="m12 3 8 4.5v9L12 21l-8-4.5v-9Z" {...s} />
    <path d="m4 7.5 8 4.5 8-4.5M12 12v9" {...s} />
  </Svg>
);

export const CartIcon = (p) => (
  <Svg {...p}>
    <path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.5a2 2 0 0 0 2-1.6L20 8H6" {...s} />
    <circle cx="10" cy="20" r="1.2" {...s} />
    <circle cx="17" cy="20" r="1.2" {...s} />
  </Svg>
);

export const CalendarIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="5" width="18" height="16" rx="2" {...s} />
    <path d="M8 3v4M16 3v4M3 11h18" {...s} />
  </Svg>
);

/* Dyskietka = ZAPISZ. Para z UploadIcon niżej: zapis odkłada pracę u siebie, publikacja
   wypuszcza ją w świat. Do 2026-08-21 oba przyciski w konstruktorze umowy miały TĘ SAMĄ
   dyskietkę, więc ikona nie odróżniała akcji odwracalnej od tej, która zmienia dokument
   wysyłany klientom. */
export const SaveIcon = (p) => (
  <Svg {...p}>
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" {...s} />
    <path d="M17 21v-8H7v8M7 3v5h8" {...s} />
  </Svg>
);

/* Podgląd (oko) — akcja „pokaż, nie zmieniaj". */
export const EyeIcon = (p) => (
  <Svg {...p}>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" {...s} />
    <circle cx="12" cy="12" r="3" {...s} />
  </Svg>
);

export const UploadIcon = (p) => (
  <Svg {...p}>
    <path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5" {...s} />
    <path d="M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" {...s} />
  </Svg>
);

/* Arkusz kalkulacyjny — kartka z siatka komorek. Uzywany tam, gdzie tresc NAPRAWDE jest
   plikiem .xlsx (import danych), a nie jako ogolna ikona dokumentu. */
export const SheetIcon = (p) => (
  <Svg {...p}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" {...s} />
    <path d="M14 3v5h5" {...s} />
    <path d="M8 12h8M8 16h8M12 12v4" {...s} />
  </Svg>
);

export const ArrowRightIcon = (p) => (
  <Svg {...p}><path d="M5 12h13m0 0-5-5m5 5-5 5" {...s} /></Svg>
);

/* Skanowanie i etykiety sprzętu (2026-09-24). */
export const CameraIcon = (p) => (
  <Svg {...p}>
    <path d="M4 8h3l2-3h6l2 3h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z" {...s} />
    <circle cx="12" cy="13" r="3.5" {...s} />
  </Svg>
);

export const PhoneIcon = (p) => (
  <Svg {...p}>
    <rect x="7" y="2.5" width="10" height="19" rx="2" {...s} />
    <path d="M11 18.5h2" {...s} />
  </Svg>
);

export const QrIcon = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="3.5" width="6" height="6" rx="1" {...s} />
    <rect x="14.5" y="3.5" width="6" height="6" rx="1" {...s} />
    <rect x="3.5" y="14.5" width="6" height="6" rx="1" {...s} />
    <path d="M14.5 14.5h2v2h-2zM18.5 18.5h2v2h-2zM18.5 14.5h2M14.5 18.5v2" {...s} />
  </Svg>
);

export const PrinterIcon = (p) => (
  <Svg {...p}>
    <path d="M7 8V3.5h10V8" {...s} />
    <rect x="3.5" y="8" width="17" height="8" rx="1.5" {...s} />
    <path d="M7 13.5h10V20.5H7z" {...s} />
  </Svg>
);
